import React from 'react';

function DisplayItem(props) {
  return (
    <>
      <div className={`app-l-action-centre-wrapper_items ${props.count > 0 ? 'active' : ''}`}>
        <div>{props.label}</div>
        <div>
          {props.count ? (
            <>
              <span className="menuWrap__menuIndi">{props.count}</span>Action(s) Pending
            </>
          ) : (
            <>No Action Needed</>
          )}
        </div>
        <a href={props.link || '#'} className="linkMarker btn-primary">
          View
        </a>
      </div>
    </>
  );
}

export default React.memo(DisplayItem);
